import React from 'react';
import ConversationBubble from '@nile/components/src/Pages/SystemTrayChatPage/subpages/ChatBubble/ConversationBubble';
import InfoText from '@nile/components/src/Pages/SystemTrayChatPage/subpages/ChatBubble/InfoMessage';
import {
  EVENT,
  SOURCE
} from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import { isEmpty } from 'lodash';

function ChatBubble({
  source,
  key,
  data,
  isCompact = false,
  sendMessage,
  threadData,
  allConversation,
  customHeaders,
  chatStatus,
  closeSession,
  clearChatData,
  readOnly = false,
  isOnDemandChatVersion
}) {
  const { type = null, data: chatData, user, event = null, isHttp = false } =
    data || {};

  const switchCase = isHttp ? type : event;
  const isWeb = source === SOURCE.WEB;
  const replyType = isWeb ? EVENT.TECH_REPLY : EVENT.REQ_REPLY;
  const isSelf = isHttp
    ? switchCase === replyType
    : chatData?.conversation?.type === replyType;

  const getChatData = () => {
    if (chatData?.hasOwnProperty('conversation')) {
      return chatData?.conversation?.data?.hasOwnProperty('promptData')
        ? null
        : chatData?.conversation?.data;
    }
    return chatData?.hasOwnProperty('promptData') ? null : chatData;
  };

  const action = getChatData(chatData);

  const renderContent = () => {
    if (isEmpty(action) || data?.type === EVENT.TEMPLATE) {
      switch (switchCase) {
        case EVENT.INITIATE_CONVERSATION:
        case EVENT.CONVERSATION_MESSAGE:
        case EVENT.TECH_REPLY:
        case EVENT.REQ_REPLY:
          return (
            <ConversationBubble
              isCompact={isCompact}
              key={key}
              data={data}
              isSelf={isSelf}
              user={user}
              type={type}
              isHttp={isHttp}
              chatStatus={chatStatus}
              threadData={threadData}
              allConversation={allConversation}
              sendMessage={sendMessage}
              isWeb={isWeb}
              customHeaders={customHeaders}
            />
          );
        case EVENT.TEMPLATE:
          return (
            <ConversationBubble
              isCompact={isCompact}
              key={key}
              data={chatData}
              isSelf={false}
              user={user}
              center
              template
              type={type}
              chatStatus={chatStatus}
              sendMessage={sendMessage}
              isHttp={isHttp}
              threadData={threadData}
              allConversation={allConversation}
              isWeb={isWeb}
              customHeaders={customHeaders}
            />
          );

        default:
          return <div />;
      }
    } else {
      switch (action?.action) {
        case EVENT.ASSET_ONLINE:
        case EVENT.REMOTE_SESSION_ENDED:
        case EVENT.REMOTE_SESSION_STARTED:
        case EVENT.REQUESTER_NOT_ACCEPTED:
        case EVENT.SESSION_CLOSED:
        case EVENT.SESSION_CONNECTED:
        case EVENT.TECH_SCREENSHOT_REQUESTED:
        case EVENT.ASSET_OFFLINE:
        case EVENT.SCREENSHOT_TAKEN:
        case EVENT.REQ_REJECTED_SCREENSHOT_REQUEST:
          return (
            <InfoText
              plainText
              isWeb={isWeb}
              message={action?.action}
              event={action?.action}
              closeSession={closeSession}
              clearChatData={clearChatData}
              readOnly={readOnly}
              isOnDemandChatVersion={isOnDemandChatVersion}
            />
          );
        default:
          return <div />;
      }
    }
  };

  return <>{renderContent()}</>;
}

export default ChatBubble;
